<script setup>
import { useForm } from '@inertiajs/vue3'


const props = defineProps({
    errors: {
        type: Object,
        default: () => ({}),
    },
    flash: {
        type: Object,
        default: () => ({}),
    },
})

const form = useForm({
    email: '',
})

const hasError = (field) => Boolean(props.errors?.[field])
const errorText = (field) => {
    const val = props.errors?.[field]
    if (!val) return ''
    return Array.isArray(val) ? val[0] : val
}
const errorMessages = (field) => (hasError(field) ? [errorText(field)] : [])

const submit = () => {
    form.post(route('forgot-password'), {})
}
</script>

<template>
    <v-dialog
        max-width="480"
        persistent
    >
        <template v-slot:activator="{ props: activatorProps }">
            <button
                v-bind="activatorProps"
                 class="font-semibold text-iron-grey hover:text-iron-grey/80"
                >
                <span>Pozabljeno geslo?</span>
            </button>
            
        </template>

        <template v-slot:default="{ isActive }">
            <v-card
                class="overflow-hidden rounded-3xl shadow-xl shadow-iron-grey-light/20"
            >
                <div class="border-b border-iron-grey-light/30 bg-linen px-6 py-4">
                    <p class="text-xs font-semibold uppercase tracking-[0.2em] text-iron-grey">Pozabljeno geslo?</p>
                    <p class="mt-1 text-base font-semibold text-iron-grey">Pozabljeno geslo?</p>
                </div>

                <v-card-text class="px-6 py-5 space-y-4">
                    <div v-if="flash.success" class="rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800" role="alert">
                        {{ flash.success }}
                    </div>
                    <div v-if="flash.error" class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
                        {{ flash.error }}
                    </div>

                    <v-form @submit.prevent="submit()">
                        <div class="space-y-4">
                            <p class="text-sm text-iron-grey/70">Vpišite svoj email in mi vam pošljemo povezavo za ponastavitev gesla.</p>
                            <v-text-field
                                v-model="form.email"
                                label="Email"
                                type="email"
                                density="comfortable"
                                variant="outlined"
                                autocomplete="email"
                                required
                                :error="hasError('email')"
                                :error-messages="errorMessages('email')"
                            ></v-text-field>

                            <div class="mt-2 flex justify-end gap-2">
                                <v-btn
                                    variant="outlined"
                                    class="text-sm font-medium bg-white text-iron-grey border-iron-grey-light hover:bg-linen"
                                    @click="isActive.value = false"
                                >
                                    Prekliči
                                </v-btn>

                                <v-btn
                                    class="text-sm font-semibold px-5 bg-white text-iron-grey border border-iron-grey-light hover:bg-linen rounded-xl"
                                    @click="submit()"
                                >
                                    Pošlji
                                </v-btn>
                            </div>
                        </div>
                    </v-form>
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
</template>
